import Axios from 'axios';

const axios = Axios.create({ baseURL: `${process.env.REACT_APP_AUTH_URL}/buyer` });

const options = {
  withCredentials: true,
};

export class AuthenticatorAPI {
  static async logout(id: number) {
    try {
      await axios.post(`/${id}/logout`, {}, { withCredentials: true });
    } catch (err) {
      /* no op */
      window.rollbar?.error(`BuyersPortal: Failed to logout. Error:`, err as any);
      console.log(err);
    }
  }

  static async login(email: string, password: string) {
    try {
      const resp = await axios.post<
        { email: string; password: string },
        { data: Record<string, string> }
      >('/login', { email, password }, options);

      return {
        error: false,
        ...resp.data,
      } as const;
    } catch (error) {
      throw error;
    }
  }

  static async oneTimePassword(email: string, medium: 'email' | 'sms') {
    try {
      const resp = await axios.post<
        { email: string; medium: string },
        {
          data: {
            phone: string;
            prettyError: any;
            request_id: string;
            status: string;
          };
        }
      >('/one-time-password', { email, medium }, options);

      if (resp.data.prettyError) {
        throw new Error('nexmo error');
      }

      return {
        error: false,
        ...resp.data,
      } as const;
    } catch (error) {
      throw error;
    }
  }

  static async otpLogin(email: string, code: string, medium: 'email' | 'sms', requestId?: string) {
    try {
      const resp = await axios.post<{}, {}>(
        '/otp-login',
        { email, code, requestId, medium },
        options,
      );

      return {
        error: false,
      } as const;
    } catch (error) {
      throw error;
    }
  }

  static async forgotPassword(email: string) {
    try {
      const res = await axios.post<{ email: string }, { data: { message: string } }>(
        '/forgot-password-email',
        { email },
      );

      return {
        error: false,
      } as const;
    } catch (error) {
      throw error;
    }
  }

  static async autoLogin(accessToken: string | null) {
    try {
      await axios.post('/view-only-login', { accessToken });
    } catch (error) {
      throw error;
    }
  }

  static async circaAutoLogin(accessToken: string | null) {
    try {
      await axios.post('/circa-auto-login', { accessToken });
    } catch (error) {
      throw error;
    }
  }
}
